import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import BookDetails from '../BookDetails/BookDetails.css';
import { jwtDecode } from 'jwt-decode';
import { api } from '../../config';
import "./BookList.css";
import { toast } from 'react-toastify';
const AuthorForm = ( {authorForm} ) => {
    const [authors, setAuthors] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const [formData, setFormData] = useState({
      author_name: authorForm ? authorForm.author_name : '',
      cover_img:   '',
      author_id: authorForm ? authorForm.author_id : ''
    });
  
    const [isUpdating, setIsUpdating] = useState(authorForm?.update ? true : false);
  
    const handleChange = (event, name, newValue) => {
        
        if(newValue === "author_id"){
            if(name){
                setFormData({
                    ...formData,
                    [name]:name.author_id,
                    author_id:name.author_id,
                    author_name:name.author_name,
                  });
                  setIsUpdating(true);
            }else{
                setFormData({
                    ...formData
                  });
                  setIsUpdating(false);
             }
        }else if(newValue === "author_name")
        {
            setFormData({
                ...formData,
                author_id:name.author_id,
                author_name:event.target.value,
              });
        }
     
    };
    const getAuthors = async () => {
        try {
          const response = await fetch(`${api}/book_author/authors`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              }
            });
           let data = await response.json();
            //console.log(data);
            setAuthors(data);
            
          }
         
         catch (error) {
          //console.log(error);
        }
      }
     
    const handleSubmit = async (event) => {
      event.preventDefault();
  
      const method = isUpdating ? 'PUT' : 'POST';
  
      const token = localStorage.getItem('token');
      if (!token) {
          // Handle the case when token is null (e.g., redirect to login page)
          //console.log('User is not authenticated. Redirecting to home page...');
          window.location.href = '/index';
          // Redirect logic or display unauthorized message
          return;
      }
      let decodedToken ='';
      if (token) {
         decodedToken = (token);
      }
      let response ='';
   
   if(isUpdating)
   {
     response = await fetch(`${api}/book_author/authors/${formData.author_id}`, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${decodedToken}` 
        },
        body: JSON.stringify({
            name: formData.author_name,
      
            token:decodedToken,
          }),
      });
    }else if(isUpdating === false){
        response = await fetch(`${api}/book_author/newAuthor/`, {
            method: method,
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${decodedToken}` 
            },
            body: JSON.stringify({
                name: formData.author_name,
          
                token:decodedToken,
              }),
          });
    }
      const data = await response.json();
      if (data.message === "Author created successfully") {
        toast.success('تم إضافة المؤلف بنجاح');
      }
      if (data.message === "Author updated successfully") {
        toast.success('تم تحديث المؤلف بنجاح');
      }
      if (data.error === "This name is already taken") {
        toast.error(' الاسم موجود مسبقا');
      }
      getAuthors();
      resetForm();
    };
  
    const handleOpen = () => {
 
 
        getAuthors();

        setShowForm(true);
    };
  
    const handleUpdateOrDelete = async (updateMode, authorId) => {
      if (updateMode) {
        const author = 
        setFormData({
          ...author
        });
        setIsUpdating(true);
      } else {
        
      const token = localStorage.getItem('token');
      if (!token) {
          // Handle the case when token is null (e.g., redirect to login page)
          //console.log('User is not authenticated. Redirecting to home page...');
          window.location.href = '/index';
          // Redirect logic or display unauthorized message
          return;
      }
      let decodedToken ='';
      if (token) {
         decodedToken = (token);
      }
    
   
       let response =  await fetch(`${api}/book_author/authors/${authorId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${decodedToken}` 
          },
          body: JSON.stringify({
             
        
              token:decodedToken,
            }),
        });
        const data = await response.json();
        if (data.message === "Author delete successfully") {
            toast.success('تم حذف المؤلف بنجاح');
          }
          getAuthors();
        // Update authors list after deletion
        // setAuthors(authorForm.filter(author => author.author_id !== authorId));
        resetForm();
      }
    };
  
    const resetForm = () => {
      setFormData({
        author_name: '',
        cover_img: '',
        author_id: ''
      });
      setIsUpdating(false);
    };
    // useEffect(() => {
    //     if (!authorForm?.update) {
    //         getAuthors();
    //     }
    //   }, [authorForm?.update]);
          return (
      <span>
          {(showForm || isUpdating) ? (
        <form className='book-details-form' onSubmit={handleSubmit}>
            <div className='book-details-form-item'>
            <label>أسم المؤلف (للتعديل)</label>
             <Autocomplete
             id="author_id"
             options={authors}
             value={authors.find(author => author.author_id === formData.author_id) || null}
             getOptionLabel={(option) => option?.author_name || ''}
             onChange={(event, newValue) => handleChange(event, newValue, 'author_id')}
             renderInput={(params) => <TextField {...params} />}
             />
          </div>
          <div className='book-details-form-item'>
          <label> اسم المؤلف {isUpdating ? '(بعد التعديل)' : ''}<span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='article_name' value={formData.author_name} onChange={(e) => handleChange(e,formData, 'author_name')} />
          </div>
          
         
         

           
          <div className='form-buttons'>
            <button type="submit">{isUpdating ? 'تعديل' : 'إضافة'}</button>
            {authorForm?.update ===true ?(null) : (<button  type="button" onClick={() => {setShowForm(false); resetForm()}}> الغاء</button>)}

            {isUpdating && (
              <button type="button" onClick={() => handleUpdateOrDelete(false, formData.author_id)}>حذف</button>
            )}
          </div>
        </form>
    ) : (
      // dont show if ArticleForm is true
      !showForm && !formData.update && (
        
          <button className="new-book-btn" onClick={() => handleOpen()}>  مؤلف  </button>
       
      )
    )}
      </span>
    );
  };
  
  export default AuthorForm;
  